<template lang="html">
    <header>
        <div class="foundationHeaderLogo">
            <img src="@/assets/img/FoundationLogoW.png"
                 alt="Foundation Logo"
                 class="foundationHeaderLogoImage" />
        </div>
        <div class="foundationHeaderTrigger">
            <Trigger :color="1"
                     title="Open Menu" />
        </div>
    </header>
    <div class="foundationHeaderSlideshow">
        <Slideshow :color="pageColor" />
    </div>
</template>

<script>
import Trigger from "@/components/Elements/ElNavigationTrigger.vue";
import Slideshow from "@/components/Slideshow/SlideshowSlideshow.vue";
import { mapGetters } from "vuex";

export default {
    name: "FoundationHeader",
    components: {
        Trigger,
        Slideshow,
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        };
    },
    computed: {
        ...mapGetters(["pageData"]),
        pageColor() {
            if (this.windowWidth > this.windowHeight) {
                return this.pageData.is_color;
            } else return this.pageData.is_color_mobile;
        },
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
    },
    created() {
        window.addEventListener("resize", this.onResize);
    },
    unmounted() {
        window.removeEventListener("resize", this.onResize);
    },
};
</script>

<style lang="css" scoped>
/* HEADER */
header {
    position: relative;
    width: 100%;
    background: #121919;
    height: 120px;
    padding: 0;
    margin: 0;
}

.foundationHeaderLogo {
    display: grid;
    height: 100%;
    width: 100%;
    place-items: center;
}

header img {
    display: block;
    position: relative;
    width: calc(100% - 64px);
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
}

.foundationHeaderTrigger {
    position: absolute;
    z-index: 999999999;
    top: 24px;
    right: 24px;
    display: grid;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.foundationHeaderSlideshow {
    position: relative;
    width: 100%;
    height: calc(100vh - 120px - 128px);
    max-height: -webkit-fill-available;
}

@media only screen and (min-width: 600px) {
    header {
        height: 150px;
        /* position: sticky;
        top: 0; */
        z-index: 9999999;
    }

    .foundationHeaderSlideshow {
        position: relative;
        width: 100%;
        height: 440px;
    }

    header img {
        max-width: 350px;
        width: 350px;
    }
}
</style>
